export default __webpack_public_path__ + "static/StevensWood_Care_Maintenance_11-16-fc4e1c0c30c2f36f70b7a4147eff2dca.pdf";